import React, { useEffect, useState } from "react";
import ModalTemplate from "../modal-template";
import SearchInput from "components/inputs/search-input";
import TextDropdown from "components/inputs/text-dropdown";
import { GetActiveArtist } from "services/user/getUser";
import api from "services/axiosInstance";
import { ITrackRelease } from "types/musicData";
import styled from "styled-components";
import Typography from "components/typography";
import { Colors } from "utils/colors";

interface IProps {
  close: () => void;
  active: boolean;
  setFilterData: (data: { releaseTitle: string; trackTitle: string }) => void;
  filterData: { releaseTitle: string; trackTitle: string };
}

const InsightsFilterReleases = ({
  close,
  active,
  setFilterData,
  filterData
}: IProps) => {
  const [release, setRelease] = useState(filterData.releaseTitle);

  const [releaseList, setReleaseList] = useState<string[]>([]);
  const [dataLoading, setDataLoading] = useState(false);

  const [track, setTrack] = useState(filterData.trackTitle);

  const [trackList, setTrackList] = useState<string[]>([]);

  const artist = GetActiveArtist();

  const GetData = async () => {
    try {
      setDataLoading(true);
      const [{ data: ReleasesData }, { data: TracksData }] = await Promise.all([
        api.get(`/songs/artist/${artist?.id}/discography`),
        api.get(`/songs/artist/${artist?.id}`)
      ]);

      //Releases
      const { singles, albums, eps } = ReleasesData.data;

      const Releases: ITrackRelease[] = [...singles, ...albums, ...eps];

      const ReleaseTitles = [];
      for (let i = 0; i < Releases.length - 1; i++) {
        const title = Releases[i].title;
        ReleaseTitles.push(title);
      }
      setReleaseList(ReleaseTitles);

      //tracks

      const tracks: ITrackRelease[] = TracksData.data;

      const TrackTitles = [];
      for (let i = 0; i < tracks.length - 1; i++) {
        const title = tracks[i].title;
        TrackTitles.push(title);
      }
      setTrackList(TrackTitles);
    } catch (err) {
      // Toast({ error });
    } finally {
      setDataLoading(false);
    }
  };

  const UpdateFilters = () => {
    setFilterData({ releaseTitle: release, trackTitle: track });
  };

  const ResetFilters = () => {
    setRelease("");
    setTrack("");
    UpdateFilters();
    close();
  };

  const ConfirmFilters = () => {
    UpdateFilters();
    close();
  };

  useEffect(() => {
    if (active) {
      GetData();
      // console.log(trackList);
      // console.log(releaseList);
    }
  }, [active]);

  return (
    <ModalTemplate
      header="Filter"
      close={ResetFilters}
      cancelText="Reset All Filters"
      confirmText="Apply Filters"
      confirm={ConfirmFilters}
      twoButtons
    >
      <LabelContainer>
        <Typography color={Colors.grey500}>Release</Typography>
        <ClearBtn onClick={() => setRelease("All Releases")}>
          <Typography>Clear</Typography>
        </ClearBtn>
      </LabelContainer>
      <TextDropdown
        value={release}
        selectItem={(val) => setRelease(val)}
        searchIcon
        listCheck
        items={releaseList}
        placeholder="All Releases"
        dataLoading={dataLoading}
      />
      <Gap />
      <LabelContainer>
        <Typography color={Colors.grey500}>Track</Typography>
        <ClearBtn onClick={() => setTrack("All Releases")}>
          <Typography>Clear</Typography>
        </ClearBtn>
      </LabelContainer>
      <TextDropdown
        value={track}
        selectItem={(val) => setTrack(val)}
        placeholder="All Tracks"
        searchIcon
        listCheck
        items={trackList}
        dataLoading={dataLoading}
      />
    </ModalTemplate>
  );
};

export default InsightsFilterReleases;

const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.8rem;
`;

const ClearBtn = styled.div`
  color: ${Colors.yellow400};
  cursor: pointer;
`;

const Gap = styled.div`
  height: 2.4rem;
`;
